import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import SalesChart from '@/components/dashboard/SalesChart';
import OverviewCard from '@/components/dashboard/OverviewCard';
import RevenueChart from '@/components/dashboard/RevenueChart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const generateOptions = ({ 
  showTitle = true, 
  title,
  yAxisTitle,
  yAxisStepSize = 2,
  yAxisMin = 0,
  yAxisMax = 10,
}) => {
  return {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: showTitle,
        text: title,
      },
    },
    scales: {
      y: {
        title: {
          display: yAxisTitle !== undefined,
          text: yAxisTitle
        },
        min: yAxisMin,
        max: yAxisMax,
        ticks: {
          stepSize: yAxisStepSize
        }
      }
    }
  };
};

const DashboardPage = () => {
  return (
    <div className='bg-gray-100'>
      <div className='bg-white text-center w-full py-5 rounded-lg'>
				<h1 className='text-2xl font-bold'>Dashboard</h1>
			</div>

      <OverviewCard />

      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mt-8'>
        <SalesChart />
        <RevenueChart />
      </div>      
    </div>
  )
}

export default DashboardPage